import { Typography } from "@mui/material";
import React, { useEffect, useState, type JSX } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { IAttachment } from "../../common/models/IAttachment";
import { fileToBase64, getApplicationMimeType } from "../../common/utilities/AttachmentHelpers";
import { useConfirmation } from "../../contexts/confirmation-context/ConfirmationContext";
import FormInput from "../forms/form-input/FormInput";
import Form from "../forms/form/Form";
import ResponsiveDialog from "../responsive-dialog/ResponsiveDialog";
import htmlParse from 'html-react-parser';
import { bindDialog, BindDialogReturn, DialogProps, DialogResult, DialogState, useDialogState } from "../../hooks/use-dialog-state/UseDialogState";

export type AttachmentDialogInitValues = {
} & IAttachment;

export type AttachmentDialogResultValues = {
    base64ImageData?: string;
    fileName: string;
    mimeType: ApplicationMimeTypesEnum;
    description: string;
}

export type AttachmentDialogResult = DialogResult<AttachmentDialogResultValues>;

export type AttachmentDialogProps = DialogProps<AttachmentDialogInitValues, AttachmentDialogResult>;

export const MAX_ATTACHMENT_SIZE_BYTES = 30000000;

type AttachmentDialogFormValuesType = {
    description: string;
    fileName: string;
}

export default function AttachmentDialog({
    open,
    onClose,
    values
}: AttachmentDialogProps): JSX.Element {
    const { t } = useTranslation();
    const isAddMode = (values?.id ?? -1) <= -1;
    const { confirm /*, acknowledge*/ } = useConfirmation();
    const [ base64Data, setBase64Data ] = useState<string>("");
    const [ mimeType, setMimeType ] = useState<ApplicationMimeTypesEnum>(ApplicationMimeTypesEnum.Binary);

    const form = useForm<AttachmentDialogFormValuesType>({
        mode: "onChange",
        defaultValues: {
            description: "",
            fileName: "",
        } as AttachmentDialogFormValuesType
    });

    const {
        handleSubmit,
        formState: {
            isDirty,
            isValid
        },
        reset,
        trigger,
        setValue
    } = form;

    useEffect(() => {
        reset({
            description: values?.description ?? "",
            fileName: values?.fileName ?? "",
        });
        setTimeout(() => {
            trigger();
        }, 0);
    }, [reset, values, trigger]);

    async function onOkay(data: AttachmentDialogFormValuesType) {
        const lastSlash = data.fileName?.lastIndexOf('\\') ?? -1;
        const fileName = data.fileName?.substring(lastSlash + 1);

        const values = {
            fileName: fileName,
            description: data.description,
            mimeType: mimeType,
            base64ImageData: base64Data,
        } as AttachmentDialogResultValues;

        reset();

        onClose && onClose({
            reason: "ok",
            values: values
        });
    }

    async function onCancel() {
        reset();
        onClose && onClose({
            reason: "cancel"
        });
    }

    async function getFileTooLargeConfirmation() {
        await confirm({
            dialogTitle: t("attachmentDialog.maxAttachmentSizeExceededTitle"),
            confirmationText: t("attachmentDialog.maxAttachmentSizeExceeded", { maxSizeBytes: MAX_ATTACHMENT_SIZE_BYTES }),
            yesButtonText: t("buttons.okay"),
            showConfirmationText: true,
            showYesButton: true,
            showNoButton: false
        });
    }

    async function handleFileChanged(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): Promise<string | undefined> {

        let name: string | undefined = undefined;
        const files = (e as React.ChangeEvent<HTMLInputElement>)?.target?.files;
        if (files && files.length > 0) {
            const file = files[0];
            if (file.size < MAX_ATTACHMENT_SIZE_BYTES) {
                setBase64Data(await fileToBase64(file));
                setMimeType(getApplicationMimeType(file));
                name = file.name;
            } else {
                await getFileTooLargeConfirmation();

                setBase64Data("");
                setMimeType(ApplicationMimeTypesEnum.Binary);

                setTimeout(() => {
                    setValue('fileName', "", {
                        shouldDirty: true,
                        shouldValidate: true
                    });
                }, 0);
            }
        } else {
            setBase64Data("");
            setMimeType(ApplicationMimeTypesEnum.Binary);
        }

        return name;
    }

    function validateNotEmpty(value: string) {
        return value && value.length > 0;
    }

    // const onPictureFile = async (event: ChangeEvent<HTMLInputElement> ) => {

    //     const result = await handleFileChanged(event);
       
    //     if (result) {

    //         setValue('fileName', result, {shouldDirty: true });
    //         trigger('fileName');

    //     }
       
    // };

    return (
        <>
            <ResponsiveDialog
                title={isAddMode ? t("attachmentDialog.addTitle") : t("attachmentDialog.editTitle") }
                enableOkay={isDirty && isValid}
                okayLabel={t("buttons.save")}
                open={open}
                onClose={
                    (reason: string) => {
                        reason === "ok"
                            ? handleSubmit(async (data) => onOkay(data))()
                            : onCancel();
                    }
                }
            >




                <Form form={form}>


                    {/* {
                        isPhone &&
                        <Box>
                            <Typography variant="subtitle1" fontWeight={600}>
                                {t("attachmentDialog.chooseType.label")}
                            </Typography>
                            <FormRadioGroup
                                name='attachmentType'
                                radioButtons={[{
                                    label: t("attachmentDialog.chooseType.file"),
                                    value: AttachmentTypeEnum.ChooseFile
                                }, {
                                    label: t("attachmentDialog.chooseType.photo"),
                                    value: AttachmentTypeEnum.ChoosePhoto
                                }]}
                                //onChanging={onTypeOfPlotOptionChanging} 
                                />
                        </Box>
                    } */}


                    {/* {
                    attachmentType === AttachmentTypeEnum.ChooseFile ? */}
                        <FormInput
                            name="fileName"
                            label={t("attachmentDialog.file")}
                            multiline={false}
                            sx={{
                                marginTop: 2
                            }}
                            rules={{
                                validate: validateNotEmpty
                            }}
                            fileUpload
                            onChange={handleFileChanged}
                        />
                    {/* : 
                        <Stack direction='row'>
                            <FormInput
                                name="fileName"
                                label={t("attachmentDialog.file")}
                                multiline={false}
                                sx={{
                                    marginTop: 2,
                                    marginRight: 1,
                                    flex: '1 1 auto'

                                }}
                                readOnly={true}

                                rules={{
                                   validate: validateNotEmpty
                                }}
                                //fileUpload
                                //onChange={handleFileChanged}
                            />         

                            <Box marginLeft='auto' marginTop='auto' marginBottom='auto'>

                                <input 
                                    id="icon-button-camera" 
                                    type="file" 
                                    accept="image/*" 
                                    style={{display: 'none'}} 
                                    capture='environment'
                                    onChange={onPictureFile} />   
                                <label style={{
                                    }} htmlFor="icon-button-camera">
                                    <IconButton 
                                        disabled={watchFileName !== ''}
                                        sx={{ 
                                        padding: 0,
                                        opacity: .8
                                        }}
                                        color="primary" aria-label="take a picture" component="span">
                                        <PhotoCamera />
                                    </IconButton>
                                </label>

                                <input id="icon-button-pic" 
                                    type="file" 
                                    accept="image/*" 
                                    style={{display: 'none'}} 
                                    onChange={onPictureFile} />   

                                <label style={{
                                    }} htmlFor="icon-button-pic">
                                    <IconButton 
                                        disabled={watchFileName !== ''}
                                        sx={{ 
                                        padding: 0,
                                        opacity: .8
                                        }}
                                        color="primary" aria-label="choose a picture" component="span">
                                        <Photo />
                                    </IconButton>
                                </label>
                            </Box>

                        </Stack>

                    } */}

                    <Typography
                        sx={{
                            color: 'green',
                            fontStyle: 'italic',
                            padding: '.5em',
                            fontSize: 'smaller'
                        }}
                    >
                        {htmlParse(t("attachmentDialog.illegalCharacters"))}
                    </Typography>



                    <FormInput
                        name="description"
                        label={t("attachmentDialog.description")}
                        multiline={true}
                        rows={6}
                        sx={{
                            marginTop: 2
                        }}
                        rules={{
                            validate: validateNotEmpty
                        }}
                    />
                </Form>
            </ResponsiveDialog>
        </>
    );
}


export type AttachmentDialogState = DialogState<AttachmentDialogInitValues, AttachmentDialogResult>;
export type BindAttachmentDialogReturn = BindDialogReturn<AttachmentDialogInitValues, AttachmentDialogResult>;

export function useAttachmentDialogState(): AttachmentDialogState {
    return useDialogState();
}

export function bindAttachmentDialog(props: AttachmentDialogState): BindAttachmentDialogReturn {
    return bindDialog(props);
}